module.exports = __webpack_public_path__ + "img/bebox_illu.37b59dce.png";